import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
    icon: {
        width: '100%',
        maxWidth: 60
    }
}));
